module.exports = __webpack_public_path__ + "img/pdf_small.ec94877c.png";